import PhotoSwipe from 'photoswipejs';
import PhotoSwipeUI_Default from 'photoswipeuijs';
import Masonry from 'masonry-layout';
import imagesloaded from 'imagesloaded'

function parseItems(container) {
    const elements = container.querySelectorAll('.hike-media');
    let items = [];
    let element, linkElement, imgElement;

    for (let i = 0; i < elements.length; i++) {
        element = elements[i]; // <div> element

        linkElement = element.children[0]; // <a> element
        imgElement = linkElement.children[0];

        // create slide object
        items.push({
            src: linkElement.getAttribute('href'),
            w: parseInt(element.getAttribute('data-width')),
            h: parseInt(element.getAttribute('data-height')),
            title: imgElement.getAttribute('alt')
            //msrc:  imgElement.getAttribute('src')
        });
    }

    return items;
}

function parseHash() {
    var hash = window.location.hash.substring(1),
        params = {};

    if(hash.length < 5) {
        return params;
    }

    var vars = hash.split('&');
    for (var i = 0; i < vars.length; i++) {
        if(!vars[i]) {
            continue;
        }
        var pair = vars[i].split('=');
        if(pair.length < 2) {
            continue;
        }
        params[pair[0]] = pair[1];
    }

    if(params.gid) {
        params.gid = parseInt(params.gid, 10);
    }

    return params;
}

// find nearest parent element
function closest(el, fn) {
    return el && ( fn(el) ? el : closest(el.parentNode, fn) );
}

export default class MediaViewer {
    photoswipe;
    htmlContainer;
    viewerHtmlElement;

    constructor(htmlContainer, viewerHtmlElement) {
        this.htmlContainer = htmlContainer;
        this.viewerHtmlElement = viewerHtmlElement;

        this.initMasonry();
        this.initEvents();
        this.tryOpenFromUrl();
    }

    initMasonry() {
        let htmlContainer = this.htmlContainer;
        imagesloaded( htmlContainer, function() {
            console.log('masonry')
            new Masonry( htmlContainer, {
                // options
                itemSelector: '.grid-item'
            });
        });
    }



    initEvents() {
        this.htmlContainer.onclick = this.onThumbnailsClick.bind(this);
    }

    open(index) {
        const items = parseItems(this.htmlContainer);
        const mediaIndex = parseInt(index, 10);

        let options = {
            index: isNaN(mediaIndex) ? 0 : mediaIndex
        };

        this.photoswipe = new PhotoSwipe(this.viewerHtmlElement, PhotoSwipeUI_Default, items, options);
        let ps = this.photoswipe;
        this.photoswipe.listen('gettingData', function(index, item) {
            if (item.w < 1 || item.h < 1) { // unknown size
                let img = new Image();
                img.onload = function() { // will get size after load
                    item.w = this.width; // set image width
                    item.h = this.height; // set image height
                    ps.invalidateCurrItems(); // reinit Items
                    ps.updateSize(true); // reinit Items
                }
                img.src = item.src; // let's download image
            }
        });
        this.photoswipe.init();
    }

    tryOpenFromUrl() {
        const hashData = parseHash();

        if (hashData.pid) {
            this.open(parseInt(hashData.pid, 10) - 1);
        }
    }

    onThumbnailsClick(e) {
        e = e || window.event;
        e.preventDefault ? e.preventDefault() : e.returnValue = false;

        var eTarget = e.target || e.srcElement;

        // find root element of slide
        var clickedListItem = closest(eTarget, function(el) {
            return (el.tagName && el.tagName.toUpperCase() === 'DIV');
        });

        if (!clickedListItem) {
            return;
        }

        // find index of clicked item by looping through all child nodes
        // alternatively, you may define index via data- attribute
        const childNodes = clickedListItem.parentNode.childNodes;
        const numChildNodes = childNodes.length;
        let nodeIndex = 0, index;

        for (var i = 0; i < numChildNodes; i++) {
            if(childNodes[i].nodeType !== 1) {
                continue;
            }

            if(childNodes[i] === clickedListItem) {
                index = nodeIndex;
                break;
            }
            nodeIndex++;
        }

        if (index >= 0) {
            // open PhotoSwipe if valid index found
            this.open(index);
        }

        return false;
    }
}
